export enum EnumMemberType {
  REGULAR = 'Regular',
  SILVER = 'Silver',
  GOLD = 'Gold',
  VIP = 'VIP',
}

export enum EnumMemberTypeCode {
  REGULAR = 0,
  SILVER = 1,
  GOLD = 2,
  VIP = 3,
}
